<template>
    <div>
        <div class="user-details__body">
            <div class="ld-shop-form-card">
            <div class="row">
                <div class="col-md-6">
                    <h3 v-if="dealerImpersonated">{{ getTranslation('user-info', 'invoice_address_dealer_impersonate') }}</h3>
                    <h3 v-if="!dealerImpersonated">{{ getTranslation('user-info', 'invoice_address') }}</h3>

                    <!-- user.address1-->
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <label  class="col-form-label" :class="getLabelClasses('user.address1')" :for="'form-order-company_name'">
                                    {{ getTranslation('user-info', 'name_company') }}
                                    <span class="req">*</span>
                                </label>

                                <input
                                    type="text"
                                    class="form-control"
                                    :class="getInputClasses('user.address1')"
                                    :placeholder="getTranslation('user-info', 'name_company')"
                                    :id="'form-order-company_name'"
                                    v-model="userInfo.address1"
                                    @input="removeInputError('user.address1')"
                                >
                                <div class="invalid-feedback" v-if="getError('user.address1')" v-text="getError('user.address1')"></div>
                            </div>
                        </div>
                    </div>

                    <!-- user.address2-->
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <input
                                    type="text"
                                    class="form-control empty-label"
                                    :class="getInputClasses('user.address2')"
                                    id="form-order-company_name2'"
                                    v-model="userInfo.address2"
                                    @input="removeInputError('user.address2')"
                                >
                                <div class="invalid-feedback" v-if="getError('user.address2')" v-text="getError('user.address2')"></div>
                            </div>
                        </div>
                    </div>

                    <!-- user.street-->
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <label  class="col-form-label" :class="getLabelClasses('user.street')" for="form-order-street">
                                    {{ getTranslation('user-info', 'street') }}
                                    <span class="req">*</span>
                                </label>

                                <input
                                    type="text"
                                    class="form-control"
                                    :class="getInputClasses('user.street')"
                                    :placeholder="getTranslation('user-info', 'street')"
                                    id="form-order-street"
                                    v-model="userInfo.street"
                                    @input="removeInputError('user.street')"
                                >
                                <div class="invalid-feedback" v-if="getError('user.street')" v-text="getError('user.street')"></div>
                            </div>
                        </div>
                        <div class="col-12 form-group-callout mb-5" v-if="poboxMessage.street">
                            {{ getTranslation('user-info', 'po_box_message') }}
                        </div>
                    </div>

                    <!-- user.city-->
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <label  class="col-form-label" :class="getLabelClasses('user.city')" for="form-order-city">
                                    {{ getTranslation('user-info', 'city') }}
                                    <span class="req">*</span>
                                </label>

                                <input
                                    type="text"
                                    class="form-control"
                                    :class="getInputClasses('user.city')"
                                    :placeholder="getTranslation('user-info', 'city')"
                                    id="form-order-city"
                                    v-model="userInfo.city"
                                    @input="removeInputError('user.city')"
                                >
                                <div class="invalid-feedback" v-if="getError('user.city')" v-text="getError('user.city')"></div>
                            </div>
                        </div>
                    </div>

                    <!-- user.zip-->
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <label  class="col-form-label" :class="getLabelClasses('user.zip')" for="form-order-zip">
                                    {{ getTranslation('user-info', 'zip') }}
                                    <span class="req">*</span>
                                </label>

                                <input
                                    type="text"
                                    class="form-control"
                                    :class="getInputClasses('user.zip')"
                                    :placeholder="getTranslation('user-info', 'zip')"
                                    id="form-order-zip"
                                    v-model="userInfo.zip"
                                    @input="removeInputError('user.zip')"
                                >
                                <div class="invalid-feedback" v-if="getError('user.zip')" v-text="getError('user.zip')"></div>
                            </div>
                        </div>
                    </div>


                    <!-- user.country_id -->
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <label  class="col-form-label" :class="getLabelClasses('user.country_id')" for="form-order-country">
                                    {{ getTranslation('user-info', 'country') }}
                                    <span class="req">*</span>
                                </label>

                                <select2
                                    class="select2 form-control" data-width="100%"
                                    v-model="userInfo.country_id"
                                    id="form-order-country"
                                    @input="handleCountryId($event)"
                                    data-theme="bootstrap4"
                                >
                                    <option
                                        v-for="country in countryList"
                                        :key="country.id"
                                        v-bind:data-code="country.iso_code"
                                        v-bind:data-is_eu="country.is_eu"
                                        v-bind:data-is_cz="country.is_cz"
                                        :value="country.id"
                                    >
                                        {{ country.name }}
                                    </option>
                                </select2>
                                <div class="invalid-feedback" v-if="getError('user.country_id')" v-text="getError('user.country_id')"></div>
                            </div>
                        </div>
                    </div>

                    <!-- user.vat_no-->
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <label  class="col-form-label" :class="getLabelClasses('user.vat_no')" for="form-order-registration_id">
                                    {{ getTranslation('user-info', 'registration_id') }}
                                </label>

                                <input
                                    type="text"
                                    class="form-control"
                                    :class="getInputClasses('user.vat_no')"
                                    :placeholder="getTranslation('user-info', 'registration_id')"
                                    id="form-order-registration_id"
                                    v-model="userInfo.vat_no"
                                    @input="removeInputError('user.vat_no')"
                                >
                                <div class="invalid-feedback" v-if="getError('user.vat_no')" v-text="getError('user.vat_no')"></div>
                            </div>
                        </div>
                    </div>


                    <!-- user.vat_id-->
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <label  class="col-form-label" :class="getLabelClasses('user.vat_id')" for="form-order-vat_number">
                                    {{ getTranslation('user-info', 'vat_number') }}

                                </label>

                                <input
                                    type="text"
                                    class="form-control"
                                    :class="[getInputClasses('user.vat_id'), vatIdClass]"
                                    :placeholder="getTranslation('user-info', 'vat_number')"
                                    id="form-order-vat_number"
                                    v-model="userInfo.vat_id"
                                    @input="removeInputError('user.vat_id')"
                                    v-on:blur="checkVatInfo()"
                                >
                                <div class="invalid-feedback" v-if="getError('user.vat_id')" v-text="getError('user.vat_id')"></div>
                            </div>
                        </div>
                        <div class="col-12 form-group-callout mb-5" v-html="getTranslation('user-info', 'vat_info_lines')"></div>

                    </div>


                </div>

                <div class="col-md-6">
                    <h3>{{ getTranslation('user-info', 'contact_information') }}</h3>


                    <!-- user.person-->
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <label  class="col-form-label" :class="getLabelClasses('user.person')" for="form-order-person">
                                    {{ getTranslation('user-info', 'name') }}
                                    <span class="req">*</span>
                                </label>

                                <input
                                    type="text"
                                    class="form-control"
                                    :class="getInputClasses('user.person')"
                                    :placeholder="getTranslation('user-info', 'name')"
                                    id="form-order-person"
                                    v-model="userInfo.person"
                                    @input="removeInputError('user.person')"
                                >
                                <div class="invalid-feedback" v-if="getError('user.person')" v-text="getError('user.person')"></div>
                            </div>
                        </div>
                    </div>

                    <!-- user.phone-->
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <label  class="col-form-label" :class="getLabelClasses('user.phone')" for="form-order-phone">
                                    {{ getTranslation('user-info', 'phone') }}
                                </label>

                                <input
                                    type="text"
                                    class="form-control"
                                    :class="getInputClasses('user.phone')"
                                    :placeholder="getTranslation('user-info', 'phone')"
                                    id="form-order-phone"
                                    v-model="userInfo.phone"
                                    @input="removeInputError('user.phone')"
                                >
                                <div class="invalid-feedback" v-if="getError('user.phone')" v-text="getError('user.phone')"></div>
                            </div>
                        </div>
                    </div>

<!--                    <h3>{{ getTranslation('user-info', 'e_mail') }}</h3>-->
                    <!-- user.email-->
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <label  class="col-form-label" :class="getLabelClasses('user.email')" for="form-order-email">
                                    {{ getTranslation('user-info', 'email') }}
                                    <span class="req">*</span>
                                </label>

                                <input
                                    type="text"
                                    class="form-control"
                                    :class="getInputClasses('user.email')"
                                    :placeholder="getTranslation('user-info', 'email')"
                                    id="form-order-email"
                                    v-model="userInfo.email"
                                    @input="removeInputError('user.email')"
                                >
                                <div class="invalid-feedback" v-if="getError('user.email')" v-html="getError('user.email')"></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="row mb-3" v-if="hasDelivery">

                <div class="col-12">
                    <h3>{{ getTranslation('user-info', 'delivery_options') }} </h3>

                    <div class="form-group">
                        <label  class="col-form-label" :class="getLabelClasses('user.phone_for_delivery')" for="form-order-delivery_phone">
                            {{ getTranslation('user-info', 'phone_for_delivery') }}
                            <span class="req" v-if="deliveryPrice()">*</span>
                        </label>

                        <input
                            type="text"
                            class="form-control"
                            :class="getInputClasses('user.delivery_phone')"
                            :placeholder="getTranslation('user-info', 'phone_for_delivery')"
                            id="form-order-delivery_phone"
                            v-model="userInfo.delivery_phone"
                            @input="removeInputError('user.delivery_phone')"
                        >
                        <div class="invalid-feedback" v-if="getError('user.delivery_phone')" v-text="getError('user.delivery_phone')"></div>
                    </div>
                </div>

            </div>

            <div class="form-row" v-if="hasDelivery">
                <div class="col-md-6">
                    <a data-toggle="collapse"
                       class="different-address "
                       :class="deliveryExpanded ? '' : 'collapsed'"
                       href="#invoice-address"
                       role="button" aria-controls="invoice-address"
                       :aria-expanded="deliveryExpanded ? 'true' : 'false'"
                    >
                        <span class="plus">
                            <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                                <path fill="currentColor" d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z" class=""></path>
                            </svg>
                        </span>
                        <span class="minus">
                            <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                                <path fill="currentColor" d="M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z" class=""></path>
                            </svg>
                        </span>
                        {{ getTranslation('user-info', 'shipping_address') }}
                    </a>

                    <div class="collapse" id="invoice-address" :class="deliveryExpanded ? 'show' : ''">
                        <div class="invoice-address__body">

                            <!-- user.shipping_address1-->
                            <div class="form-group">
                                <label  class="col-form-label" :class="getLabelClasses('user.shipping_address1')" for="form-order-shipping-address1">
                                    {{ getTranslation('user-info', 'name_company') }}

                                </label>

                                <input
                                    type="text"
                                    class="form-control"
                                    :class="getInputClasses('user.shipping_address1')"
                                    :placeholder="getTranslation('user-info', 'name_company')"
                                    id="form-order-shipping-address1"
                                    v-model="userInfo.shipping_address1"
                                    @input="removeInputError('user.shipping_address1')"
                                >
                                <div class="invalid-feedback" v-if="getError('user.shipping_address1')" v-html="getError('user.shipping_address1')"></div>
                            </div>

                            <!-- user.shipping_address2-->
                            <div class="form-row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control empty-label"
                                            :class="getInputClasses('user.shipping_address2')"
                                            id="form-order-shipping-address2"
                                            v-model="userInfo.shipping_address2"
                                            @input="removeInputError('user.shipping_address2')"
                                        >
                                        <div class="invalid-feedback" v-if="getError('user.shipping_address2')" v-text="getError('user.shipping_address2')"></div>
                                    </div>
                                </div>
                            </div>

                            <!-- user.shipping_street-->
                            <div class="form-row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label  class="col-form-label" :class="getLabelClasses('user.shipping_street')" for="form-order-shipping-street">
                                            {{ getTranslation('user-info', 'street') }}
                                        </label>

                                        <input
                                            type="text"
                                            class="form-control"
                                            :class="getInputClasses('user.shipping_street')"
                                            :placeholder="getTranslation('user-info', 'street')"
                                            id="form-order-shipping-street"
                                            v-model="userInfo.shipping_street"
                                            @input="removeInputError('user.shipping_street')"
                                        >
                                        <div class="invalid-feedback" v-if="getError('user.shipping_street')" v-text="getError('user.shipping_street')"></div>
                                    </div>
                                </div>
                                <div class="col-12 form-group-callout mb-5" v-if="poboxMessage.shipping_street">
                                    {{ getTranslation('user-info', 'po_box_message') }}
                                </div>
                            </div>

                            <!-- user.shipping_city-->
                            <div class="form-row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label  class="col-form-label" :class="getLabelClasses('user.city')" for="form-order-shipping-city">
                                            {{ getTranslation('user-info', 'city') }}
                                        </label>

                                        <input
                                            type="text"
                                            class="form-control"
                                            :class="getInputClasses('user.shipping_city')"
                                            :placeholder="getTranslation('user-info', 'city')"
                                            id="form-order-shipping-city"
                                            v-model="userInfo.shipping_city"
                                            @input="removeInputError('user.shipping_city')"
                                        >
                                        <div class="invalid-feedback" v-if="getError('user.shipping_city')" v-text="getError('user.shipping_city')"></div>
                                    </div>
                                </div>
                            </div>

                            <!-- user.shipping_zip-->
                            <div class="form-row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label  class="col-form-label" :class="getLabelClasses('user.shipping_zip')" for="form-order-shipping-zip">
                                            {{ getTranslation('user-info', 'zip') }}
                                        </label>

                                        <input
                                            type="text"
                                            class="form-control"
                                            :class="getInputClasses('user.shipping_zip')"
                                            :placeholder="getTranslation('user-info', 'zip')"
                                            id="form-order-shipping-zip"
                                            v-model="userInfo.shipping_zip"
                                            @input="removeInputError('user.shipping_zip')"
                                        >
                                        <div class="invalid-feedback" v-if="getError('user.shipping_zip')" v-text="getError('user.shipping_zip')"></div>
                                    </div>
                                </div>
                            </div>


                            <!-- user.shipping_country_id -->
                            <div class="form-row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label  class="col-form-label" :class="getLabelClasses('user.shipping_country_id')" for="form-order-shipping-country">
                                            {{ getTranslation('user-info', 'country') }}
                                        </label>

                                        <select2
                                            class="form-control select2" data-width="100%"
                                            v-model="userInfo.shipping_country_id"
                                            id="form-order-shipping-country"
                                            data-theme="bootstrap4"
                                            @input="handleShippingCountry($event)"
                                        >
                                            <option
                                                v-for="country in countryList"
                                                :key="country.id"
                                                v-bind:data-code="country.iso_code"
                                                v-bind:data-is_eu="country.is_eu"
                                                v-bind:data-is_cz="country.is_cz"
                                                :value="country.id"
                                            >
                                                {{ country.name }}
                                            </option>
                                        </select2>
                                        <div class="invalid-feedback" v-if="getError('user.shipping_country_id')" v-text="getError('user.shipping_country_id')"></div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>


                </div>
                <div class="col-md-6">
                    <div class="form-group-callout py-3 mb-4">
                        <p class="my-2">
                            {{ getTranslation('user-info', 'fill_in_for_different_address') }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="row" v-if="$store.state.cart.hasDelivery">
                <div class="col-12">
                    <div class="delivery-cost">
                        {{ getTranslation('user-info', 'delivery_price') }} <span class="ml-auto text-black" v-html="priceFormat(deliveryPrice(), true)"></span>
                    </div>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-md-12">
                    <h3>{{ getTranslation('user-info', 'licence_agreement_privacy') }}</h3>
                    <div class="form-group">

                        <!-- newsletter -->
                        <div class="form-group" v-if="!dealerImpersonated">
                            <div class="custom-control custom-checkbox ">
                                <input
                                    id="newsletter"
                                    type="checkbox"
                                    class="custom-control-input"
                                    v-model="userInfo.newsletter"
                                >
                                <label
                                    for="newsletter"
                                    class="custom-control-label "
                                    v-html="getTranslation('user-info', 'newsletter_label', {newsletter_url: configUrls.web_privacy_newsletter_url})"
                                >
                                </label>
                            </div>
                        </div>


                        <!-- agreement -->
                        <div class="form-group">
                            <div class="custom-control custom-checkbox" :class="getInputClasses('agreement')">
                                <input
                                    id="agreement"
                                    type="checkbox"
                                    class="custom-control-input"
                                    v-model="userInfo.agreement"
                                    @change="removeInputError('agreement')"
                                >
                                <label
                                    v-if="!dealerImpersonated"
                                    for="agreement"
                                    class="custom-control-label "
                                    v-html="getTranslation('user-info', 'agree_label', {agreement_url: configUrls.web_licence_agreement_url}) +  '<span class=req>*</span>'"
                                ></label>
                                <label
                                    v-if="dealerImpersonated"
                                    for="agreement"
                                    class="custom-control-label "
                                    v-html="getTranslation('user-info', 'dealer_agree_label', {agreement_url: configUrls.web_licence_agreement_url}) +  '<span class=req>*</span>'"
                                ></label>

                            </div>
                            <div class="invalid-feedback" v-if="getError('agreement')" v-text="getError('agreement')"></div>
                        </div>


                        <!-- privacy -->
                        <div class="form-group">
                            <div class="custom-control custom-checkbox" :class="getInputClasses('privacy')">
                                <input
                                    id="privacy"
                                    type="checkbox"
                                    class="custom-control-input"
                                    v-model="userInfo.privacy"
                                    @change="removeInputError('privacy')"
                                >
                                <label
                                    v-if="!dealerImpersonated"
                                    for="privacy" class="custom-control-label "
                                    v-html="getTranslation('user-info', 'privacy_label', {privacy_url: configUrls.web_privacy_policy_url}) + '<span class=req>*</span>'"
                                ></label>
                                <label
                                    v-if="dealerImpersonated"
                                    for="privacy" class="custom-control-label "
                                    v-html="getTranslation('user-info', 'dealer_privacy_label', {privacy_url: configUrls.web_privacy_policy_url}) + '<span class=req>*</span>'"
                                ></label>


                            </div>
                            <div class="invalid-feedback" v-if="getError('privacy')" v-text="getError('privacy')"></div>
                        </div>


                    </div>
                </div>
            </div>

            <div class="form-row" v-if="showPromoBox()">
                <div class="col-12">
                    <div class="form-group">
                        <label  class="col-form-label"  for="form-order-promo_code">
                            {{ getTranslation('user-info', 'promo_code') }}
                        </label>

                        <input
                            type="text"
                            class="form-control"
                            :placeholder="getTranslation('user-info', 'promo_code')"
                            id="form-order-promo_code"
                            v-model="userInfo.promo_code"
                        >
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="form-group mt-3 mb-5" >
                        <label for="order_note">{{ getTranslation('front', 'NOTE') }}</label>
                        <textarea id="order_note" class="form-control" v-model="userInfo.note" rows="5" cols="40"></textarea>
                    </div>
                </div>
            </div>
            </div>
        </div>

        <div class="user-details__footer">
            <a v-bind:href="navigation.licences_setup"  class="btn btn-back">
                <svg width="15" height="13" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path fill="currentColor" d="M231.536 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113L238.607 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"></path>
                </svg>
                {{ getTranslation('front', 'back') }}
            </a>
            <button @click="checkUserInfo()" type="submit" class="btn btn-primary btn-order submitbtn submitUserInfo continue">
                {{ getTranslation('front', 'continue') }}
            </button>
            <a href="javascript:;"  class="btn btn-primary btn-order submitbtn continue-spinner d-none">
                <span class="d-flex align-items-center">
                    <b-spinner small variant="light" label="Loading..."></b-spinner> {{ getTranslation('front', 'loading')}}
                </span>
            </a>

        </div>

        <b-modal id="bv-modal-warning" centered hide-footer>
            <template #modal-title>
                <div class="modal-title__icon">
                    <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" ><path fill="currentColor" d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z"></path>
                    </svg>
                </div>
                <span>{{ getTranslation('key-setup-vue', 'warning') }}</span>
            </template>
            <div class="d-block text-center">
                <p>{{ submitErrorMessage }}</p>
                <br><br>
            </div>
            <div class="text-center">
                <b-button class="mt-3 mx-auto"  @click="closeModal()">{{ getTranslation('front', 'close') }}</b-button>
                <template v-if="submitError != -1">
                    <a :href="baseUrl + '/empty-cart'" class="mt-3 mx-auto btn btn-secondary">{{ getTranslation('front', 'empty_cart')}}</a>
                </template>
            </div>
        </b-modal>

        <b-modal id="bv-modal-duplicate" centered hide-footer>
            <template #modal-title>
                <div class="modal-title__icon">
                    <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" ><path fill="currentColor" d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z"></path>
                    </svg>
                </div>
                <span>{{ getTranslation('user-info', 'warning') }}</span>
            </template>
            <div class="d-block text-center">
                <div v-html="getTranslation('user-info', 'modal_existing_line_1')"></div>
                <div v-html="duplicateUserMessage"></div>
                <div v-html="getTranslation('user-info', 'modal_existing_line_2')"></div>
                <br><br>
            </div>
            <div class="text-center">
                <a :href="baseUrl + '/login'" class="mt-3 mx-auto btn btn-secondary">{{ getTranslation('auth', 'login')}}</a>
                <b-button class="mt-3 mx-auto"  @click="confirmPotentialDuplicate()">{{ getTranslation('front', 'continue') }}</b-button>
            </div>
        </b-modal>
    </div>

</template>

<script>
    export default {
        methods: {
            showPromoBox () {
                if (this.loggedInUser) {
                    return false;
                }
                if (this.dealerImpersonated) {
                    return false;
                }
                return true;
            },
            closeModal() {
                this.$bvModal.hide('bv-modal-warning');
            },
            confirmPotentialDuplicate() {
                this.$bvModal.hide('bv-modal-duplicate');
                this.userInfo.confirmModal = 1;
                this.checkUserInfo();
            },
            deliveryPrice() {
                if (!this.hasDelivery) {
                    return 0;
                }

                let countryId = '';
                if (this.userInfo.shipping_country_id) {
                    countryId = this.userInfo.shipping_country_id;
                } else if (this.userInfo.country_id) {
                    countryId = this.userInfo.country_id;
                }

                let selectedCountry = _.find(this.countryList, function(c) {
                    return c.id == countryId;
                });

                let deliveryPrice = 0;

                if (!_.isNil(selectedCountry) && selectedCountry.delivery) {
                    deliveryPrice = this.getDeliveryPrice();
                }
                if (this.shopConfigOptions.language != 'cs' && _.isNil(selectedCountry)) {
                    deliveryPrice = this.getDeliveryPrice();
                }

                return deliveryPrice;
            },
            setDelivery() {
                let deliveryPrice = this.deliveryPrice();
                let payload = {'deliveryPrice': deliveryPrice};
                this.$store.commit('setDelivery', payload);
            },
            getCollapsed() {
                if (this.userInfo.shipping_address1) {
                    return '';
                }
                return 'collapsed';
            },
            checkHasDelivery() {
                let hasDelivery = true
                let hardlocks = this.$store.state.cart.hardlocks.filter(h => {
                    return (h.isNew == 1 && h.hasDelivery==1);
                });
                if (hardlocks.length <= 0) {
                    hasDelivery = false;
                }
                if (this.dealerImpersonated) {
                    hasDelivery = false;
                }

                this.$store.commit('setHasDelivery', {hasDelivery: hasDelivery});
                return hasDelivery;
            },
            initUserInfo() {
                if (!_.isNil(this.$store.state.cart.userInfo) && !_.isEmpty(this.$store.state.cart.userInfo)) {
                    return _.clone(this.$store.state.cart.userInfo);
                }
                if (!_.isNil(this.kanUserInfo) && !_.isEmpty(this.kanUserInfo)) {
                    return this.kanUserInfo;
                }
                let payload = {
                    'address1': '',
                    'address2': '',
                    'street': '',
                    'city': '',
                    'zip': '',
                    'country_id': '',
                    'vat_no': '',
                    'vat_id': '',
                    'person': '',
                    'phone': '',
                    'shipping_address1': '',
                    'shipping_address2': '',
                    'shipping_street': '',
                    'shipping_city': '',
                    'shipping_zip': '',
                    'shipping_country_id' : '',
                    'delivery_phone': '',
                    'newsletter': '',
                    'privacy': '',
                    'agreement': '',
                    'note': this.userNote,
                    'promo_code': ''
                };
                this.$store.commit('setUserInfo', payload);
                return payload;
            },
            getLabelClasses(name) {
                let classNames = '';
                if (this.getError(name)) {
                    classNames += 'is-invalid';
                }
                return classNames;
            },
            getInputClasses(name) {
                let classNames = '';
                if (this.getError(name)) {
                    classNames += 'is-invalid';
                }
                if (name == 'user.vat_id') {
                    if (
                        !_.isNil(this.$store.state.cart.vatInfo) &&
                        !_.isNil(this.$store.state.cart.vatInfo.result) &&
                        this.$store.state.cart.vatInfo.result == 2
                    ) {
                        classNames += 'is-valid';
                    }
                }
                return classNames;
            },
            getError(name) {
                if (_.isNil(this.userInfoErrors) || _.isNil(this.userInfoErrors[name])) {
                    return '';
                }
                return this.userInfoErrors[name][0];
            },
            removeInputError(name) {
                this.userInfoErrors[name] = '';
                if (name == 'user.street') {
                    this.updatePoBoxMessage('street');
                }
                if (name == 'user.shipping_street') {
                    this.updatePoBoxMessage('shipping_street');
                }
            },
            updatePoBoxMessage(name) {
                let x = this.userInfo[name];
                if (x && x.toLowerCase().includes('po box')) {
                    this.poboxMessage[name] = true;
                } else {
                    this.poboxMessage[name] = false;
                }
            },
            handleCountryId(selected) {
                let selectedCountry = _.find(this.countryList, function(c) {
                    return c.id == selected;
                });


                if (!_.isNil(selectedCountry) && !_.isUndefined(this.userInfo.vat_id) && this.userInfo.vat_id.length <= 2) {
                    this.userInfo.vat_id = selectedCountry.iso_code;
                }
                this.removeInputError('user.country_id');
                this.setDelivery();
                this.callVatInfo();
            },
            handleShippingCountry() {
                this.removeInputError('user.shipping_country_id');
                this.setDelivery();
            },
            hasSubscriptionPromo() {
                if (_.isNil(this.$store.state.cart.subscriptionPromo)) {
                    return false;
                }
                if (_.isEmpty(this.$store.state.cart.subscriptionPromo)) {
                    return false;
                }
                return true;
            },
            checkUserInfo() {
                if (this.canSubmit == false) {
                    return;
                }
                this.setSpinner();
                this.canSubmit = false;
                let self = this;
                this.userInfoErrors = {};

                let postData =  {
                    user: this.userInfo,
                    privacy: this.userInfo.privacy ? this.userInfo.privacy : null,
                    agreement: this.userInfo.agreement ? this.userInfo.agreement : null,
                    hasDelivery: this.hasDelivery,
                    programs: this.$store.state.cart.programs,
                    hardlocks: this.$store.state.cart.hardlocks,
                    maintenance: this.$store.state.cart.maintenance,
                    singleUpgrade: this.$store.state.cart.singleUpgrade,
                    softwareLanguage: this.$store.state.cart.softwareLanguage,
                    leaseProlong: this.$store.state.cart.leaseProlong,
                    leaseProlongConfigs: this.$store.state.cart.leaseProlongConfigs,
                    additionalLanguages: this.$store.state.cart.additionalLanguages,
                    programLanguages: this.$store.state.cart.programLanguages,
                    trussPeriod: this.$store.state.cart.trussPeriod,
                    forceUserLevel: this.$store.state.cart.forceUserLevel,
                    subscriptionPromo: this.hasSubscriptionPromo(),
                    existingPerpetualUpgrade: this.$store.state.cart.perpetualUpgrade,

                };
                axios.post(this.baseUrl + '/validate-user-info', postData)
                    .then(function( response ) {
                        if (_.isNil(response.data.status)) {
                            //backend error, the response is not well formatted
                            self.handleError(-1);
                        } else if (response.data.status == 0) {
                            self.userInfoErrors = response.data.message;
                            setTimeout(function() {
                                if ($('.invalid-feedback').length) {
                                    $('html, body').animate({
                                        scrollTop: $('.invalid-feedback:visible:first').offset().top - 80
                                    }, 400);
                                }
                            }, 200);
                        } else {
                            self.$store.commit('setUserInfo', {data: self.userInfo});
                            self.$store.commit('setVatInfo', {data: self.vatInfo});

                            self.setDelivery();
                            if (!_.isNil(response.data.duplicateError)) {
                                // self.duplicateUserMessage = response.data.duplicateError;
                                self.canSubmit = true;
                                self.resetSpinner();
                                self.$bvModal.show('bv-modal-duplicate');
                            } else if (_.isNil(response.data.hardlockError)) {
                                let payload = {'step': 4};
                                self.$store.commit('setCartStep', payload);
                                payload = {'text': self.userInfo.note};
                                self.$store.commit('setUserNote', payload);
                                window.location.href = self.navigation.order_summary;
                                return;
                            } else {
                                self.handleError(response.data.hardlockError);
                            }
                        }
                        self.canSubmit = true;
                        self.resetSpinner();

                    }).catch(function( error ) {
                        //backend error

                        self.canSubmit = true;
                        self.resetSpinner();
                        self.userInfoErrors = error.response.data.errors;
                        if (_.isNil(error.response.data.errors)) {
                            self.handleError(-1);
                        }
                        setTimeout(function() {
                            if ($('.invalid-feedback').length) {
                                $('html, body').animate({
                                    scrollTop: $('.invalid-feedback:visible:first').offset().top - 80
                                }, 400);
                            }
                        }, 200);

                    });

            },
            handleError(code, type = false) {
                this.submitError = code;
                //console.log()

                if (this.submitError == -1) {
                    this.submitErrorMessage = this.getTranslation('key-setup-vue', 'error_backend_response');
                } else if (this.submitError == 2) {
                    this.submitErrorMessage = this.getTranslation('key-setup-vue', 'error_new_licenses');
                } else if (this.submitError == 3) {
                    this.submitErrorMessage = this.getTranslation('key-setup-vue', 'error_old_licenses');
                } else if (this.submitError == 4) {
                    this.submitErrorMessage = this.getTranslation('key-setup-vue', 'error_allocated_licenses');
                } else if (this.submitError == 'maintenance') {
                    this.submitErrorMessage = this.getTranslation('product-list-vue', 'single_upgrade_maintenance_warning_text');
                }

                if (code != 1) {
                    this.$bvModal.show('bv-modal-warning');
                }
            },
            checkVatInfo() {
                if (_.isEmpty(this.vatInfo)) {
                    this.callVatInfo();
                    return;
                }
                //this is already calculated
                if (this.userInfo.country_id == this.vatInfo.country && this.userInfo.vat_id == this.vatInfo.vat && this.vatInfo.result >= 0) {
                    if (this.vatInfo.result == 2) {
                        this.vatIdClass = 'is-valid';
                    }
                    return;
                }
                this.callVatInfo();
            },
            callVatInfo() {
                let self = this;
                let apiResult = this.$store.state.cart.vatInfo;
                let postData = {
                    country: this.userInfo.country_id,
                    vatid: this.userInfo.vat_id,
                };
                axios.get(this.baseUrl + '/validate-vat', {params: postData})
                    .then(function( response ) {
                        if (!_.isNil(response.data['info'])) {
                            self.vatInfo = response.data['info'];
                            if (response.data['info']['result'] == 2) {
                                self.vatIdClass = 'is-valid';
                            } else {
                                self.vatIdClass = '';
                            }
                        } else {
                            self.vatIdClass = '';
                            self.vatInfo = {};
                        }
                    }).catch(function( error ) {
                        //backend error
                        self.vatInfo = {};
                        self.vatIdClass = '';

                    });
            },
            initVatInfo() {
                if (
                    _.isEmpty(this.vatInfo) &&
                    this.userInfo.country_id &&
                    this.userInfo.vat_id
                ) {
                    this.checkVatInfo();
                }
            },
            getDeliveryExpanded() {
                if (this.userInfo.shipping_address1) {
                    return true;
                }
                return false;
            }
        },
        beforeMount() {
            this.userNote = this.$store.state.cart.userNote;
            this.userInfo = this.initUserInfo();
            if (this.checkHasDelivery()) {
                this.hasDelivery = true;
            }
            this.userInfo.note = this.userNote;
            if (_.isEmpty(this.promoInfo)) {
                this.promoInfo['code'] = '';
                this.userInfo.promo_code = '';
            } else {
                this.userInfo.promo_code = this.promoInfo.code;
            }

        },
        mounted () {
            window.userInfo=this;
            this.initVatInfo();
            this.setDelivery();
            this.deliveryExpanded = this.getDeliveryExpanded();
            this.updatePoBoxMessage('street');
            this.updatePoBoxMessage('shipping_street');
        },
        data() {
            return {
                deliveryErrorMsg: window.deliveryErrorMsg || '',
                normalDeliveryPrice: window.normalDeliveryPrice || 0,
                expressDeliveryPrice: window.expressDeliveryPrice,
                userInfo: {},
                userInfoErrors: {},
                vatInfo: this.$store.state.cart.vatInfo,
                baseUrl: window.baseUrl,
                countryList: window.jsonCountries,
                hasDelivery: false,
                navigation: window.quickNavigationUrls,
                kanUserInfo: window.kanUserInfo,
                submitError: false,
                submitErrorMessage: false,
                canSubmit: true,
                userNote: '',
                shopConfigOptions: window.shopConfigOptions,
                duplicateUserMessage: '',
                deliveryExpanded: false,
                dealerImpersonated: window.dealerImpersonated,
                loggedInUser: window.loggedInUser,
                promoInfo: window.promoInfo,
                vatIdClass: '',
                poboxMessage: {street:false, shipping_street: false},
                configUrls: window.configUrls
            };
        }
    }

    $(document).on('select2:open', () => {
        document.querySelector('.select2-search__field').focus();
    });
</script>
